import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Button = styled.div`
  width: auto;
  height: auto;
  color: ${(props) => props.color || "#000000"};
  font-weight: bold;
  font-size: 15px;
`;
const ClickButtonOuter = styled.div`
  width: auto;
  height: auto;
  color: ${(props) => props.color || "#000000"};
  font-weight: bold;
  font-size: 15px;
  &:hover {
    opacity: 0.6;
  }
  cursor: pointer;
`;


class ClickButtonAtom extends PureComponent {

    render() {
        return (
          <ClickButtonOuter>
            <Button
              typo={this.props.typo}
              color={this.props.color}
              onClick={this.props.onClick}
              className={this.props.className}
            >
              {this.props.text}
            </Button>
          </ClickButtonOuter>
        );
    }
}

export default ClickButtonAtom;